import React from 'react';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import cx from 'classnames';
import * as yup from 'yup';

import { didPropChange } from 'utils/props';
import { Urls } from 'constants/constants';

import AppState, { selectCurrentUser } from 'store/AppState';
import User from 'store/models/User';
import Account, { selectAccountSettings } from 'store/models/Account';
import RouteState from 'store/RouteState';


import { ContentCenter, Header, Title, HeaderLeft, HeaderRight } from 'components/Content';
import Card, { CardHead, CardTitle, CardInputItem, ItemLabel, ItemInput } from 'components/Card';
import BodyTag from 'components/BodyTag';
import TextInput from 'components/forms/TextInput';
import Button from 'components/Button';

import { withForm } from 'components/forms/Form';
import Label from 'components/forms/Label';
import ActionBar from 'components/ActionBar';




// ======================
// FORM
// ====================== 
const SCHEMA = {
  cpm: {
    default: 0.50,
    validate: yup.number().min(0.10).required(),
    transformOut: v => parseFloat(v),
  },
}

const FORM_NAMES = ["cpm"];


// ======================
// STORE
// ====================== 
const actions = {
  fetchData: () => {
    return dispatch => {

    }
  },
 
  navigate: RouteState.actions.navigate,
};

const selectors = createSelector(
  selectCurrentUser,
  selectAccountSettings,
  (user, settings) => Object.assign({ user, settings })
)

const withConnect = connect(selectors, actions);



// ======================
// COMPONENT
// ====================== 
class ChatSettings extends React.Component {

  componentDidMount() {
    //this.props.setSchema(SCHEMA);
    //if(this.props.settings)
    //  this.props.setDefaults(_.pick(this.props.settings, FORM_NAMES))
  }

  componentDidUpdate(prev) {
    //if(didPropChange(this.props, prev, 'settings')) {
    //  this.props.setDefaults(_.pick(this.props.settings, FORM_NAMES))
    //}
  }

  onSave = async () => {
    return;

    let { updateSettings, values } = this.props;

    let isValid = await this.props.validate();
    if(!isValid)
      return;

    this.setState({ saving: true });
    try {
      await updateSettings(values);
      this.setState({ saving: false });
      this.onSuccess();
    } catch(err) {
      this.setErrors({ server: err.message });
    }
  }

  onSuccess = () => {
    //this.props.navigate(Urls.DASHBOARD);
  }

  render() {
    let { values, errors, onInputChange } = this.props;

    return (
      <ContentCenter className="settings">
        <Header split={true}>
          <HeaderLeft>
            <Title>Chat Bot</Title>
          </HeaderLeft>
        </Header>
        
        <Card>
          <CardHead>
            <CardTitle>Settings</CardTitle>
          </CardHead>
          <CardInputItem>
            <ItemLabel>
              <Label>Posting Frequency</Label>
            </ItemLabel>
            <ItemInput>
              <TextInput
                name="frequency"
                value={values.frequency}
                onChange={onInputChange}
                helper={"How often links will be posted in chat in minutes"} />
            </ItemInput>
          </CardInputItem>
        </Card>

        <ActionBar type="fixed">
          <Button onClick={this.onSave}>Save</Button>
        </ActionBar>
      </ContentCenter>);
  }
}
export default ChatSettings
  |> withConnect
  |> withForm;



